import React, { FC } from 'react'
import { CellularSavedCard } from './types'
import { useFormStyles } from './form-styles'
import { formatCardExpiry, formatSavedCard } from './format'
import { PaymentMethodChoice } from './use-cellular-payment'

interface PaymentMethodOptionsProps {
  savedCard: CellularSavedCard
  method: PaymentMethodChoice
  disabled?: boolean
  onChange: (method: PaymentMethodChoice) => void
}

interface OptionProps {
  value: PaymentMethodChoice
  checked: boolean
  disabled?: boolean
  onChange: (method: PaymentMethodChoice) => void
}

const Option: FC<OptionProps> = ({ value, checked, disabled, onChange, children }) => {
  const classes = useFormStyles()
  return (
    <label
      className={`${classes.option} ${checked ? classes.optionSelected : ''}`}
      htmlFor={`cellular-card-${value}`}
    >
      <input
        checked={checked}
        className={classes.radio}
        disabled={disabled}
        id={`cellular-card-${value}`}
        name='cellular-payment-method'
        onChange={() => onChange(value)}
        type='radio'
        value={value}
      />
      {children}
    </label>
  )
}

// The mock's radio cards: the card on file, or "Use a different card".
// The saved card has no cardholder name in our data, so the second line shows the expiry only.
export const PaymentMethodOptions: FC<PaymentMethodOptionsProps> = ({
  savedCard,
  method,
  disabled,
  onChange
}) => {
  const classes = useFormStyles()
  return (
    <div
      className={classes.options}
      role='radiogroup'
    >
      <Option
        checked={method === 'saved'}
        disabled={disabled}
        onChange={onChange}
        value='saved'
      >
        <div className={classes.optionText}>
          <p className={classes.optionTitle}>{formatSavedCard(savedCard)}</p>
          <p className={classes.optionSub}>Expires {formatCardExpiry(savedCard)}</p>
        </div>
        <span className={classes.optionSub}>On file</span>
      </Option>
      <Option
        checked={method === 'new'}
        disabled={disabled}
        onChange={onChange}
        value='new'
      >
        <span className={classes.optionTitle}>Use a different card</span>
      </Option>
    </div>
  )
}
